import React__default, { useMemo } from 'react';
import styles from '../styles/articleBodyNews.module.scss.esm.js';
import { templateTypes } from '../types.esm.js';

function getStyles(promoLabel) {
  return "\n.Enhancement-item{\n  .Promo{\n    &::before{\n      content: \"".concat(promoLabel, "\";\n    }\n  }\n}\n");
}
var ArticleBody = function ArticleBody(props) {
  var showFullArticle = props.showFullArticle,
    body = props.body,
    templateType = props.templateType,
    promoLabel = props.promoLabel;
  var style = templateType === templateTypes.enterprise ? styles.enterprise : 'description';
  var stylesInnerHtml = useMemo(function () {
    return {
      __html: getStyles(promoLabel)
    };
  }, [promoLabel]);
  var articleInnerHtml = useMemo(function () {
    return {
      __html: body
    };
  }, [body]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("style", {
    dangerouslySetInnerHTML: stylesInnerHtml
  }), /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-body",
    className: "article-body-html ".concat(style, " ").concat(!showFullArticle ? styles.fadeout : ''),
    dangerouslySetInnerHTML: articleInnerHtml
  }));
};

export { ArticleBody };
//# sourceMappingURL=article-body.esm.js.map
